// src/icons/index.js

// Import Material UI icons
import {
  Dashboard as DashboardIcon,
  CalendarToday as CalendarIcon,
  People as ClientsIcon,
  Engineering as EngineersIcon,
  BusinessCenter as ProjectsIcon,
  FolderOpen as FolderOpenIcon,
  Schedule as ClockIcon,
  CheckCircle as CheckCircleIcon,
  Visibility as EyeIcon,
  Edit as PenLineIcon,
  Description as FileTextIcon,
  Assessment as FileBarChartIcon,
  Settings as SettingsIcon,
  Checklist as ClipboardListIcon,
  Download as DownloadIcon,
  Build as CogIcon,
  Search as SearchIcon,
  Notifications as NotificationIcon,
  Message as MessageIcon,
  ChevronRight,
  ChevronDown,
  ExpandMore,
  ExpandLess,
  Person as ProfileIcon,
  Logout as LogoutIcon,
  Add as PlusIcon,
  FilterList as FilterIcon,
  MoreVert as MoreVertIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  ArrowDownward,
  ArrowUpward,
  PersonAdd as PersonAddIcon,
  ListAlt as ListAltIcon,
  CloudDownload as CloudDownloadIcon,
  AdminPanelSettings as AdminPanelSettingsIcon,
  History as HistoryIcon,
  Add as AddIcon,
  Home as HomeIcon,
  LocationOn as LocationIcon,
  Business as BusinessIcon,
  Phone as PhoneIcon,
  Email as EmailIcon,
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
  Sort as ArrowUpDownIcon,
  DragIndicator as GripVerticalIcon,
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
  DragIndicator as DragIndicatorIcon,
  Undo,
} from "@mui/icons-material";

import {
  IconSmartHome,
  IconCalendarStats,
  IconUsers,
  IconUserCog,
  IconBrandDatabricks,
  IconBrandFirebase,
  IconCircleDashed,
  IconProgressCheck,
  IconRosetteDiscountCheck,
  IconSignatureOff,
  IconSignature,
  IconCalendarWeek,
  IconSettings,
  IconProgressHelp,
  IconFileArrowRight,
  IconDeviceIpadHorizontalStar,
  IconCirclePlus2,
  IconBellZ,
  IconCaretDown,
  IconSearch,
  IconSquareRoundedPlus,
  IconPencil,
  IconBrowserX,
  IconTrashX,
  IconGripVertical,
  IconZoomScan,
  IconProgressBolt,
  IconTrash,
  IconArrowsSort,
  IconListTree,
  IconRotateClockwise,
  IconUsersGroup,
  IconFoldUp,
  IconFoldDown,
  IconUserCircle,
  IconAt,
  IconPhoneDone,
  IconArrowNarrowRight,
  IconX,
  IconChecks,
  IconMapPin,
  IconCalendarMonth,
  IconCornerDownRightDouble,
  IconCalendarRepeat,
  IconCalendarDown,
  IconCalendarUp,
  IconCalendarUser,
  IconBarrierBlock,
  IconCalendarFilled,
  IconCheck,
  IconArrowBackUp,
  IconArrowForwardUp,
  IconDownload,
  IconView360Arrow,
  IconDualScreen,
  IconMenu2,
  IconTrendingUp,
  IconWallpaper,
  IconClock24,
  IconUserPlus,
  IconCircleDashedX,
  IconTimelineEventX,
  IconClipboardX,
  IconAlignLeft,
  IconAlignCenter,
  IconAlignRight,
  IconAlignJustified,
  IconList,
  IconListNumbers,
  IconSquarePlus2,
  IconCalendarCheck,
  IconHome,
  IconBuildingSkyscraper,
  IconBuildingWarehouse,
  IconBuildings,
  IconBuildingBurjAlArab,
  IconBorderLeftPlus,
  IconSitemap,
  IconEdit,
  IconCreditCard,
  // IconCornerDownRightDouble
} from "@tabler/icons-react";
export const ICONS = {
  // Sidebar Icons
  dashboard: IconSmartHome,
  calendar: IconCalendarStats,
  clients: IconUsers,
  engineers: IconUserCog,
  projects: IconBrandDatabricks,
  "folder-open": IconBrandFirebase,
  clock: IconCircleDashed,
  "check-circle": IconProgressCheck,
  completed: IconRosetteDiscountCheck,
  eye: EyeIcon,

  "credit-card": IconCreditCard,
  "pen-line": IconSignatureOff,
  "file-text": IconSignature,
  "file-bar-chart": IconCalendarWeek,
  settings: IconSettings,
  "clipboard-list": IconProgressHelp,
  download: IconFileArrowRight,
  cog: IconDeviceIpadHorizontalStar,

  // Header Icons
  search: IconSearch,
  notification: IconBellZ,
  message: IconCalendarWeek,
  "chevron-down": ExpandMoreIcon, // Use ExpandMoreIcon for chevron-down
  "chevron-right": ExpandLessIcon, // Use ExpandLessIcon for chevron-right (rotated)
  "expand-more": IconCaretDown,
  "expand-less": IconCaretDown,

  // Action Icons
  profile: IconUserCircle,
  logout: LogoutIcon,
  plus: IconCirclePlus2,
  plus2: IconSquareRoundedPlus,
  filter: FilterIcon,
  "more-vert": MoreVertIcon,
  edit: IconPencil,
  delete: IconTrashX,
  close: IconBrowserX,
  "arrow-down": ArrowDownward,
  "arrow-up": ArrowUpward,
  // Add these new icons
  //'users': PersonAddIcon,
  // 'clipboard-list': ListAltIcon,
  // 'download': CloudDownloadIcon,
  // 'cog': AdminPanelSettingsIcon,
  // 'file-text': HistoryIcon,
  // 'plus': AddIcon,
  home: HomeIcon,
  location: LocationIcon,
  business: BusinessIcon,
  phone: PhoneIcon,
  email: EmailIcon,
  "arrow-up-down": ArrowUpDownIcon,
  filter: FilterIcon,
  "grip-vertical": IconGripVertical,
  "chevron-left": ChevronLeftIcon,
  "chevron-right": ChevronRightIcon,
  "drag-indicator": DragIndicatorIcon,
  Action1: IconZoomScan,
  Action2: IconProgressBolt,
  Action3: IconPencil,
  Action4: IconTrash,
  sort: IconArrowsSort,
  list: IconListTree,
  rotate: IconRotateClockwise,
  users: IconUsers,
  usersGroup: IconUsersGroup,
  foldUp: IconFoldUp,
  foldDown: IconFoldDown,
  at: IconAt,
  phoneDone: IconPhoneDone,
  arrowRight: IconArrowNarrowRight,
  close2: IconX,
  check: IconChecks,
  location2: IconMapPin,
  calendar2: IconCalendarMonth,
  downArrow: IconCornerDownRightDouble,
  calendarTomorrow: IconCalendarRepeat,
  calendarToday: IconCalendarDown,
  calendarYesterday: IconCalendarUp,
  calendarAll: IconCalendarUser,
  calendarCustom: IconCalendarMonth,
  block: IconBarrierBlock,
  calendar3: IconCalendarFilled,
  check2: IconCheck,
  undo: IconArrowBackUp,
  redo: IconArrowForwardUp,
  download1: IconDownload,
  view1: IconView360Arrow,
  menu: IconMenu2,
  trending: IconTrendingUp,
  wallpaper: IconWallpaper,
  clock1: IconClock24,
  Action5: IconUserPlus,
  close3: IconCircleDashedX,
  endDate: IconTimelineEventX,
  close4: IconClipboardX,
  // Text editor icons
  alignLeft: IconAlignLeft,
  alignCenter: IconAlignCenter,
  alignRight: IconAlignRight,
  alignJustify: IconAlignJustified,
  listUnordered: IconList,
  listOrdered: IconListNumbers,
  squarePlus: IconSquarePlus2,
  calendarCheck: IconCalendarCheck,
  home1: IconHome,
  building: IconBuildingSkyscraper,
  factory: IconBuildingWarehouse,
  layers: IconBuildings,
  hotel: IconBuildingBurjAlArab,
  borderPlus: IconBorderLeftPlus,
  downArrow2: IconCornerDownRightDouble,
  sitemap: IconSitemap,
  edit1: IconEdit,
};

// Helper component for rendering icons
export const Icon = ({ name, size = 20, stroke = 1.5, color, ...props }) => {
  const IconComponent = ICONS[name];
  if (!IconComponent) return null;

  return <IconComponent size={size} stroke={stroke} color={color} {...props} />;
};
